import React from "react";
import { useNavigate } from "react-router-dom";
import PendingVolunteerList from "../../components/DashboardInfo/PendingVolunteerList";
import { ThemButton } from "../../components/Login/Login.style";
import { MainDiv } from "../../components/Profile/Profile.style";
import { SearchAddDiv } from "../../components/style/Table.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";
import StorageVolunteerList from "../../components/DashboardInfo/StorageVolunteerList";
import useProfile from "../../hooks/useProfile";

const StoragePage = () => {
  const navigate = useNavigate();
  const [userData, isLoading] = useProfile();
  if (isLoading) {
    return "";
  }
  const user = userData?.ugleve_name;

  return (
    <MainDiv>
      <SearchAddDiv>
        <VolunteerHeading>Storage</VolunteerHeading>
        <div
          style={
            {
              // display: "flex",
              // justifyContent: "center",
            }
          }
        >
          <ThemButton onClick={() => navigate("/")}>
            Back to dashboard
          </ThemButton>
        </div>
      </SearchAddDiv>
      <StorageVolunteerList user={user} />
    </MainDiv>
  );
};

export default StoragePage;
